var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdm-stripe',{attrs:{"text":_vm.percentage.text,"color":_vm.percentage.color}})}
var staticRenderFns = []

export { render, staticRenderFns }